import { createContext } from 'react';


 interface iDeleteModal {
    open:boolean,remove:Function,message:string,
    drawer_parent?:boolean
}
const DeleteModalContext = createContext<{openDeleteModal:iDeleteModal
    ,setOpenDeleteModal:Function}>({
 openDeleteModal:{
    open:false,remove:()=>{},message:''
 },
 setOpenDeleteModal:()=>{}
});

export default DeleteModalContext;
